module.exports = __webpack_public_path__ + "img/newchris-32.ba4b8f45.jpg";